/*
 * Public API Surface of ng-modal
 */

export * from './lib/components/modal-window.component';
export * from './lib/services/modal-manager.service';
export * from './lib/modal-manager.module';
